import { getRestApiConfig } from './../../../api/config';
import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import axios from 'axios'

interface GtmProps
{
    pageName: string
    synonym?: string | undefined
}

export const useGtmPageView = ({ pageName, synonym }: GtmProps) => {
    const [userId, setUserId] = useState('')

    const getUserId = async () =>
    {
        const restApiConfig = getRestApiConfig()
        const endpointURL = new URL(`api/v1/Users/Me`, restApiConfig.baseUrl).href
        const response = await axios.get(endpointURL, { headers: { ...restApiConfig.authHeader } })
        setUserId(response.data.id)
    }

    useEffect(() => {
        getUserId()
        if(userId !== '') {
            TagManager.dataLayer({
                dataLayer: {
                    'event': 'pageView',
                    'customerID': userId,
                    'synonym': synonym || undefined,
                    'pageName': pageName,
                }
            });
        }
    }, [pageName, synonym, userId])
}